export default "<p>table-account-hotel works!</p>\n"